// extracted by mini-css-extract-plugin
export const gallery = "Gallery-module--gallery--2oLbd";
export const title = "Gallery-module--title--2L2QL";
export const thumbs = "Gallery-module--thumbs--1cJ1M";